import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/heart-black.png'


const _withScopeId = n => (_pushScopeId("data-v-0481560b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-p1" }, "Have Some Nutrition", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Eat something nutritious, and greet each new day vitalitly！", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "card_cont" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "card_cont-img"
}, null, -1))
const _hoisted_7 = { class: "card_cont-title" }
const _hoisted_8 = { class: "card_cont-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("img", {
            src: i.image
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(i.name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(i.desc), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}